import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productRatingAriaLabel: {
    id: 'pd.header.productRating.ariaLabel',
    defaultMessage:
      'Hodnocení produktu: {rating} z 5 od {count} uživatelů - přejít na další hodnocení',
  },
});
